import { useState, useEffect } from 'react';
import { IJobBoard } from 'wisestep-api';

import { getJobBoards } from '../../../jobs/publish/components/helper/jobBoardHelper';

const useJobBoardSettings = () => {
  const [jobBoardResponse, setJobBoardResponse] = useState<{
    Monster: IJobBoard[];
    Dice: IJobBoard[];
    TechFetch: IJobBoard[];
    CareerBuilder: IJobBoard[];
    CWJobs: IJobBoard[];
  }>({
    Monster: [],
    Dice: [],
    TechFetch: [],
    CareerBuilder: [],
    CWJobs: [],
  });

  useEffect(() => {
    const jobBoards = async () => {
      const allJobBoards = await getJobBoards('Monster,Dice,TechFetch,CareerBuilder,CWJobs');
      const groupedJobBoards = allJobBoards.reduce(
        (grouped, jobBoard) => {
          grouped[jobBoard.jobBoardName].push(jobBoard);
          return grouped;
        },
        {
          Monster: [],
          TechFetch: [],
          Dice: [],
          CareerBuilder: [],
          CWJobs: [],
        }
      );
      setJobBoardResponse(groupedJobBoards);
    };
    jobBoards();
  }, []);
  return jobBoardResponse;
};
export default useJobBoardSettings;
